/**
 * Fetch browser safe config from the server
 * @module services/config
 */
import request from 'services/request'
import { fromJS } from 'immutable'
import _get from 'lodash/get'
import { createAuthorization } from '../auth'

/**
 * Get a list of redirects
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.offset The query offset
 * @param {number} options.limit The query limit
 */
export async function getRedirectsList (options = {}) {
  const {
    server, auth, offset, limit, source, redirect, type,
  } = options
  const res = await request
    .get(`${server}/v1/path-redirects/list`)
    .query({
      offset, limit, source, redirect, type,
    })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * Update (or create if no id present) a redirect, allows partial update
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.id The path redirect id
 * @param {Map} options.data The POST request body
 */
export async function upsertRedirect (options = {}) {
  const { server, auth, data } = options
  // console.log(data.toJS())
  const res = await request
    .post(`${server}/v1/path-redirects`)
    .send(data.toJS())
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(_get(res, 'body', {}))
}

/**
 * Remove a redirect
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} id The id of the redirect to remove
 */
export async function deleteRedirect ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/v1/path-redirects/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return _get(res, 'body', {})
}
